<template>
  <v-dialog v-model="dialog" scrollable persistent max-width="600px">
    <template v-slot:activator="{ on }">
      <v-tooltip bottom>
        <template #activator="{ on: onTooltip }">
          <v-btn
            v-on="{ ...on, ...onTooltip }"
            class="mt-1 pa-2"
            :color="isFiltered ? 'white' : 'primary'"
            :dark="!isFiltered"
            dense
            depressed
            style="min-width: unset;"
          >
            <v-icon>filter_list</v-icon>
          </v-btn>
        </template>
        <span>filtre avançat</span>
      </v-tooltip>
    </template>

    <v-card>
      <v-card-title>
        <span class="headline">Filtre avançat</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <form-vjsf
              :formId="formId"
              :formData="form"
              @submitForm="submitForm($event)"
              style="width: 100%;"
            />
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" class="mr-4" small @click="cancel">
          Cancel·lar
        </v-btn>
        <v-btn type="submit" :form="formId" color="success" class="px-6" small>
          Cercar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  components: {
    formVjsf: () => import("@/components/FormVjsf.vue"),
  },
  props: {
    form: {
      type: Object,
      required: true,
    },
  },
  data: function() {
    return {
      dialog: false,
    }
  },
  methods: {
    cancel() {
      this.dialog = false
    },
    submitForm() {
      this.$emit("filterItems", this.form.model, () => {
        this.dialog = false
      })
    },
  },
  computed: {
    formId() {
      return "advanced_filter"
    },
    isFiltered() {
      let filters = 0
      for (let filter in this.form.model) {
        if (this.form.model[filter].length > 0) {
          filters++
        }
      }
      return filters !== 0
    },
  },
}
</script>

<style scoped />
